import { Eye } from "lucide-react";
import { FC } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "~/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";
import { trackEvent } from "~/utils/analytics";
import { useSkyViewStore } from "../../../store";

export const ReferenceHighlightsToggle: FC = () => {
  const { formatMessage } = useIntl();
  const referenceHighlightsEnabled = useSkyViewStore(
    (state) => state.referenceHighlightsEnabled
  );
  const setReferenceHighlightsEnabled = useSkyViewStore(
    (state) => state.setReferenceHighlightsEnabled
  );

  if (referenceHighlightsEnabled) return null;

  const handleReEnable = () => {
    setReferenceHighlightsEnabled(true);
    trackEvent({
      eventName: "app/doc_viewer/click_references_toggle.button/click",
      properties: { enabled: true },
    });
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-lg bg-card shadow-lg shadow-black/10 text-muted-foreground hover:text-foreground"
          onClick={handleReEnable}
          aria-label={formatMessage({
            id: "docViewer.referenceHighlights.enable",
          })}
        >
          <Eye className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <FormattedMessage id="docViewer.referenceHighlights.enable" />
      </TooltipContent>
    </Tooltip>
  );
};
